module.exports = __webpack_public_path__ + "img/voov.68aa47b1.png";